import React from "react";

export const Page11English = () => {
  return (
    <div>
      <div className="page-container">
        <div className="page-tamil-heading">
          <h1>Rasi</h1>
          <p>Nakshatras and Paadams</p>
        </div>

        <table className="tamil-table">
          <thead>
            <tr>
              <th>Rasi</th>
              <th>Nakshatras and Paadams</th>
            </tr>
          </thead>
          <tbody>
           
            <tr>
              <td>Mesham (1)</td>
              <td>
                Aswini (1,2,3am Paadangal), Bharani, Krithigai (1am Paadam)
              </td>
            </tr>
            <tr>
              <td>Rishabam (2)</td>
              <td>
                Krithigai (2,3,4am Paadangal), Rohini, Mirugasheersham (1,2am
                Paadangal)
              </td>
            </tr>
            <tr>
              <td>Mithunam (3)</td>
              <td>
                Mirugasheersham (3,4am Paadangal), Thiruvadhirai, Punarpoosam
                (1,2,3am Paadangal)
              </td>
            </tr>
            <tr>
              <td>Kadagam (4)</td>
              <td>Punarpoosam (4am Paadam), Poosam, Ayilyam</td>
            </tr>
            <tr>
              <td>Simmam (5)</td>
              <td>Magham, Pooram, Uthiram (1am Paadam)</td>
            </tr>
            <tr>
              <td>Kanni (6)</td>
              <td>
                Uthiram (2,3,4am Paadangal), Hastham, Chithirai (1,2am
                Paadangal)
              </td>
            </tr>
            <tr>
              <td>Thulam (7)</td>
              <td>
                Chithirai (3,4am Paadangal), Swathi, Visaagam (1,2,3am
                Paadangal)
              </td>
            </tr>
            <tr>
              <td>Viruchigam (8)</td>
              <td>Visaagam (4am Paadam), Anusham, Kettai</td>
            </tr>
            <tr>
              <td>Dhanusu (9)</td>
              <td>Moolam, Pooradam, Uthiraadam (1am Paadam)</td>
            </tr>
            <tr>
              <td>Magaram (10)</td>
              <td>
                Uthiraadam (2,3,4am Paadangal), Thiruvonam, Avittam (1am Paadam)
              </td>
            </tr>
            <tr>
              <td>Kumbam (11)</td>
              <td>
                Avittam (2,3,4am Paadangal), Sathayam, Poorattadhi (1,2,3am
                Paadangal)
              </td>
            </tr>
             <tr>
              <td>Meenam (12)</td>
              <td>Poorattadhi (4am Paadam), Uthirattadhi, Revathi</td>
            </tr>
          </tbody>
        </table>
      <p style={{marginTop:"10px"}}>
          Out of these 27 stars, 18 stars can immediately know their zodiac sign
          in this zodiac sign. The other 9 stars can be found by looking at
          their horoscope to see which foot of a particular star they were born
          under and then knowing their zodiac sign.
        </p>
      </div>
    </div>
  );
};
